var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSofa(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 63,
    viewBox: "0 0 78 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0343 53.625H55.6076C57.8828 53.625 59.0222 53.625 60.04 53.4812C64.1921 52.8986 67.7837 50.5865 69.716 47.2493C70.1917 46.4307 70.5494 45.4683 71.2684 43.5397L75.3984 32.4772C76.9287 28.3656 73.5067 24.125 68.6614 24.125C65.6745 24.125 63.0047 25.7954 61.987 28.3066L58.2995 37.4C57.5804 39.1626 57.2227 40.0439 56.5442 40.6561C56.1706 40.9929 55.7416 41.262 55.2573 41.4636C54.3797 41.825 53.3324 41.825 51.2342 41.825H25.4955C24.415 41.825 23.873 41.825 23.3936 41.7254C22.3019 41.5191 21.3279 40.9096 20.6649 40.0181C20.3994 39.6494 20.215 39.1921 19.8462 38.285L15.7974 28.3066C14.7796 25.7991 12.1099 24.125 9.12298 24.125C4.2776 24.125 0.855604 28.3656 2.38592 32.4735L7.19073 45.3539L7.33454 45.7301C9.16723 50.3948 14.0569 53.5476 19.5881 53.6213L20.0343 53.625Z",
    stroke: "#0F4BFF",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7673 31.5V18.8556C16.7673 10.909 16.7673 6.93756 19.3596 4.46694C21.9519 1.99631 26.1225 2 34.4673 2H43.3173C51.6621 2 55.8327 2 58.425 4.47063C61.0173 6.93388 61.0173 10.9053 61.0173 18.8519V31.5",
    stroke: "#0F4BFF",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0173 61V53.625M16.7673 61V56.0846",
    stroke: "#0F4BFF",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSofa);
export default __webpack_public_path__ + "static/media/sofa.26f08366b63c5a25d9f1f69f4c71ad5d.svg";
export { ForwardRef as ReactComponent };